import FormConfig from '../ConfigurationFormConfig';

/**
 * AreaManagerNew (DWA-A 138-1)
 *
 * Responsibility:
 * - initAreaType1381Handlers, addAreaType1381, removeAreaType1381
 * - onCategoryChange1381, onTypeChange1381, fillTypeOptions1381
 * - updateIndexes1381, toggleRemoveButtons1381, decodeHtmlEntities
 *
 * Notes:
 * - Behaviour is kept 1:1 from ConfigurationForm.js, only extracted into this class.
 * - Calls to updateFormData/updateSummary now go through the provided host (ConfigurationForm) instance.
 *   // CHANGE: Use host.updateFormData()/host.updateSummary() because logic moved to manager.
 * - Added console.log at critical actions (init/add/remove/category/type parsing).
 */
export default class AreaManagerNew {
    /**
     * @param {jQuery} form
     * @param {Object} state
     * @param {Object} host instance of ConfigurationForm (for callbacks and helpers)
     */
    constructor(form, state, host) {
        this.form = form;
        this.state = state;
        this.host = host;

        // CHANGE: Read centralized areaTypeMax from FormConfig.settings; keep safe fallback
        this.areaTypeMax = (FormConfig.settings && typeof FormConfig.settings.areaTypeMax !== 'undefined')
            ? FormConfig.settings.areaTypeMax
            : 14;
        this.areaTypeCount1381 = 0;
        this.surfaceTypesMap = {};
    }

    /**
     * CHANGE: Moved from ConfigurationForm to AreaManagerNew
     * Fill Cm or Cs select with range 0–1 (steps 0.05) for manual surface type input (DWA-A 138-1)
     * Uses centralized step from FormConfig.settings and host.createOptionElement() helper.
     *
     * @param $select jQuery select element (Cm or Cs dropdown)
     * @param initialValue optional initial value to preselect
     */
    fillCmCsSelect($select, initialValue = null) {
        if (!$select.length || !$select[0]) {
            return;
        }

        const select = $select[0];
        // clear options
        select.options.length = 0;

        // Range from 1 down to 0 (same direction as legacy fillCoefficientSelect)
        let value = 1.0;
        // Use centralized step, keep safe fallback for BC
        const step = (FormConfig.settings && typeof FormConfig.settings.coefficientStep !== 'undefined')
            ? FormConfig.settings.coefficientStep
            : -0.05;
        const minValue = 0.0;

        while (value >= minValue) {
            select.options.add(
                // reuse host helper to keep option creation consistent
                this.host.createOptionElement(value, value)
            );
            // floating point shenanigans
            value = Math.round((value + step) * 100) / 100;
        }

        // Preselect initial value if provided
        if (initialValue !== null && initialValue !== '') {
            $select.val(String(initialValue));
        }
    }

	disableIfSingleOption($select) {
		if ($select.length && $select[0]) {
			if ($select[0].options.length === 1) {
				$select.addClass('disabled');
			} else {
				$select.removeClass('disabled');
			}
		}
	}

    // Decode a JSON string embedded in a HTML data-* attribute (handles &quot; &amp; &lt; &gt;)
    decodeHtmlEntities(str) {
        return str
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');
    }

    initAreaType1381Handlers() {
        const $container = $('#areaGuideline1381');
        if (!$container.length) {
            return; // 138-1 UI not present
        }

        // Parse JSON mapping from data attribute (provided by server)
        let mapJson = $container.attr('data-surface-types-map');
        try {
            if (mapJson && typeof mapJson === 'string') {
                mapJson = this.decodeHtmlEntities(mapJson);
                this.surfaceTypesMap = JSON.parse(mapJson);
            } else {
                this.surfaceTypesMap = {};
            }
        } catch (e) {
            console.error('[AreaManagerNew] Failed to parse surfaceTypesMap', e); // CHANGE: log error
            this.surfaceTypesMap = {};
        }
        console.log('[AreaManagerNew] surfaceTypesMap initialized', this.surfaceTypesMap);

        // Bind events for add/remove and selects (delegated for dynamic rows)
        this.form.on('click', FormConfig.selectors.addAreaType1381Button, e => {
            e.preventDefault();
            this.addAreaType1381();
            return false;
        });

        this.form.on('click', FormConfig.selectors.removeAreaType1381Button, e => {
            e.preventDefault();
            const $block = $(e.currentTarget).closest(FormConfig.selectors.areaTypeBlock1381);
            this.removeAreaType1381($block);
            return false;
        });

        this.form.on('change', FormConfig.selectors.surfaceCategory1381, e => {
            this.onCategoryChange1381($(e.currentTarget));
			this.clearAreaCategorization($(e.currentTarget));
			this.toggleAreaCategorizationRows();
        });

        this.form.on('change', FormConfig.selectors.surfaceType1381Select, e => {
            this.onTypeChange1381($(e.currentTarget));
			this.clearAreaCategorization($(e.currentTarget));
        });

        // Bind change handlers for all 138-1 inputs to trigger updateFormData (like old path)
        this.form.on('change', FormConfig.selectors.surfaceType1381Input, e => {
            this.host.updateFormData(e.target); // CHANGE
        });
        this.form.on('change', FormConfig.selectors.cm1381, e => {
            this.host.updateFormData(e.target); // CHANGE
        });
        /*this.form.on('change', FormConfig.selectors.cs1381, e => {
            this.host.updateFormData(e.target); // CHANGE
        });*/
        // Area inputs within 138-1 blocks
        this.form.on('change', FormConfig.selectors.areaTypeBlock1381 + ' ' + FormConfig.selectors.areaInput, e => {
            this.host.updateFormData(e.target); // CHANGE
        });

		this.form.on('click', FormConfig.selectors.areaCategorizationDisplayToggle, e => {
			const $target = $(e.currentTarget);
			this.toggleAreaCategorizationRows();
			$target.parents(FormConfig.selectors.areaTypeBlock1381).find(FormConfig.selectors.areacategorizationSelection).toggle();
		});
		this.form.on('click', FormConfig.selectors.areacategorizationRow, e => {
			const $target = $(e.currentTarget),
				$selection = $target.parents(FormConfig.selectors.areacategorizationSelection),
				index = $selection.data('index'),
				$display = $(`${FormConfig.selectors.areaCategorizationDisplayToggle}[data-index="${index}"]`),
				$input = $(`${FormConfig.selectors.areacategorizationInput}[data-index="${index}"]`),
				category = $target.find(FormConfig.selectors.loadCategory).html(),
				id = $target.data('id');

			$selection.find(FormConfig.selectors.areacategorizationRow).removeClass('act');
			$target.addClass('act');
			$input.val(id);
			$display.val(category);
			this.host.updateFormData($input[0]);
			$selection.hide();
		});

        // Initialize existing rows
        this.areaTypeCount1381 = $(FormConfig.selectors.areaTypeBlock1381).length || 1;
        this.toggleRemoveButtons1381();

        $(FormConfig.selectors.areaTypeBlock1381).each((i, el) => {
            const $row = $(el);
            const $cat = $row.find(FormConfig.selectors.surfaceCategory1381);
            const $typeSelect = $row.find(FormConfig.selectors.surfaceType1381Select);
            const $typeInput = $row.find(FormConfig.selectors.surfaceType1381Input);
            const $cm = $row.find(FormConfig.selectors.cm1381);
            const $area = $row.find(FormConfig.selectors.areaInput);

            const storedCategory = $cat.data('initial-value') || $cat.val();
            const storedTypeUid = $typeSelect.data('initial-value') || $typeSelect.val();
            const storedManualType = $typeInput.data('initial-value') || $typeInput.val();
            const storedCm = $cm.data('initial-value') || $cm.val();
            const storedArea = $area.data('initial-value') || $area.val();

            if ($cat.length && storedCategory) {
                console.log('[AreaManagerNew] Initializing row', i, {
                    category: storedCategory,
                    storedTypeUid: storedTypeUid,
                    storedCm: storedCm,
                    storedArea: storedArea
                });

                // Initialize categories but pass the stored type UID to prevent overwriting
                this.onCategoryChange1381($cat, true, storedTypeUid);

                // Ensure area is set (re-check after triggers)
                if (storedArea) {
                    $area.val(storedArea);
                }

                // For manual category, we need to ensure cm selection is restored
                if (storedCategory === 'manual' && storedCm) {
                    $cm.val(storedCm);
                    // Also ensure the manual input field is shown and populated
                    $typeInput.val(storedManualType).show();
                    $typeSelect.hide();
                }
            }

            if (storedArea && !$area.val()) {
                $area.val(storedArea);
            }

			this.disableIfSingleOption($cm);
        });
        console.log('[AreaManagerNew] init handlers complete, row count', this.areaTypeCount1381);
    }

    addAreaType1381() {
        if (this.areaTypeCount1381 >= this.areaTypeMax) {
            $(FormConfig.selectors.addAreaType1381Button).hide();
            $(FormConfig.selectors.addAreaType1381LimitReached).show();
            console.log('[AreaManagerNew] addAreaType1381: limit reached', this.areaTypeCount1381);
            return;
        }

        const $template = $(FormConfig.selectors.areaTypeBlock1381).last();
        const $clone = $template.clone();

        // Reset values in clone
        $clone.find(FormConfig.selectors.surfaceCategory1381).prop('selectedIndex', 0);
        const $typeSelect = $clone.find(FormConfig.selectors.surfaceType1381Select);
        if ($typeSelect.length && $typeSelect[0]) {
            $typeSelect[0].options.length = 0;
        }
        $clone.find(FormConfig.selectors.surfaceType1381Input).val('').hide();
        $clone.find(FormConfig.selectors.surfaceType1381Select).show();
        $clone.find(FormConfig.selectors.cm1381).val('');
        //$clone.find(FormConfig.selectors.cs1381).val('');
        $clone.find(FormConfig.selectors.areaInput).val('');
		$clone.find(FormConfig.selectors.areacategorizationInput).val('');
		$clone.find(FormConfig.selectors.areaCategorizationDisplayToggle).val('');
		$clone.find(FormConfig.selectors.areacategorizationSelection).hide();

        $template.after($clone);
        this.areaTypeCount1381++;
        this.updateIndexes1381();
		this.onCategoryChange1381($clone.find(FormConfig.selectors.surfaceCategory1381));
        this.toggleRemoveButtons1381();
        console.log('[AreaManagerNew] addAreaType1381: new count', this.areaTypeCount1381);

        // Initialize the new row: trigger category change to fill type dropdown
        const $newCat = $clone.find(FormConfig.selectors.surfaceCategory1381);
        if ($newCat.length && $newCat.val()) {
            this.onCategoryChange1381($newCat, false);
        }

        this.host.updateSummary(); // CHANGE
    }

    removeAreaType1381($block) {
        if ($(FormConfig.selectors.areaTypeBlock1381).length > 1) {
            $block.remove();
            this.areaTypeCount1381--;
            this.updateIndexes1381();
            console.log('[AreaManagerNew] removeAreaType1381: new count', this.areaTypeCount1381);
        }
        this.toggleRemoveButtons1381();
        this.host.updateSummary(); // CHANGE
    }

    toggleRemoveButtons1381() {
        const $removeButtons = $(FormConfig.selectors.removeAreaType1381Button);
        $removeButtons.toggle($removeButtons.length !== 1);

        if (this.areaTypeCount1381 >= this.areaTypeMax) {
            $(FormConfig.selectors.addAreaType1381Button).hide();
            $(FormConfig.selectors.addAreaType1381LimitReached).show();
        } else {
            $(FormConfig.selectors.addAreaType1381Button).show();
            $(FormConfig.selectors.addAreaType1381LimitReached).hide();
        }
    }

    updateIndexes1381() {
        const $blocks = $(FormConfig.selectors.areaTypeBlock1381);
        $blocks.each((idx, block) => {
            const $el = $(block);
            // Reindex all inputs/selects inside the block
            $el.find('input[name], select[name], textarea[name]').each((i, input) => {
                if (!input.name) {
                    return;
                }
                // Extbase-style names: ...[surfaceValue][<n>][...]
                if (/(\[surfaceValue\]\[)\w+(\]\[)/.test(input.name)) {
                    input.name = input.name.replace(/(\[surfaceValue\]\[)\w+(\]\[)/, `$1${idx}$2`);
                    return;
                }
                // Legacy local names used only for UI (category/manual helpers)
                if (/(surfaceCategory|surfaceType|surfaceTypeManual|cm|cs)\[(\w+)\]/.test(input.name)) {
                    input.name = input.name.replace(/(surfaceCategory|surfaceType|surfaceTypeManual|cm|cs)\[(\w+)\]/, `$1[${idx}]`);
                }
            });
			$el.find('[data-index]').each((i, element) => {
				element.dataset.index = idx;
			});
        });
    }

    onCategoryChange1381($categorySelect, initial = false, storedTypeUid = null) {
        const $block = $categorySelect.closest(FormConfig.selectors.areaTypeBlock1381);
        const val = $categorySelect.data('initial-value') || $categorySelect.val();
		$categorySelect.data('initial-value', '');
        const $typeSelect = $block.find(FormConfig.selectors.surfaceType1381Select);
        const $typeInput = $block.find(FormConfig.selectors.surfaceType1381Input);
        const $cm = $block.find(FormConfig.selectors.cm1381);
        //const $cs = $block.find(FormConfig.selectors.cs1381);

        if (val === 'manual') {
            // Manual case: show freitext for type, fill Cm/Cs dropdowns with range 0–1
            $typeInput.val('').show();
            if (initial) {
                // In edit mode, we might have a manual text stored already
                const storedManualType = $typeInput.data('initial-value') || $typeInput.val();
                $typeInput.val(storedManualType);
            }
            $typeSelect.hide();
            // Do not submit a stale surfacetype when manual is active
            $typeSelect.val('');
            $typeSelect.prop('disabled', true);
            // Ensure manual type is submitted
            $typeInput.prop('disabled', false);
            // CHANGE: fillCmCsSelect moved into AreaManagerNew (was host)
            const storedCm = $cm.data('initial-value') || $cm.val();
            this.fillCmCsSelect($cm, initial ? storedCm : null);
			//const storedCs = $cs.data('initial-value') || $cs.val();
            //this.fillCmCsSelect($cs, initial ? storedCs : null);
            $cm.prop('disabled', false);
			this.disableIfSingleOption($cm);
            // Validation: require manual type text and Cm selection
            if ($typeInput.length) {
                $typeInput.prop('required', true);
            }
            if ($typeSelect.length) {
                $typeSelect.prop('required', false);
            }
            if ($cm.length) {
                $cm.prop('required', true);
            }
            //if ($cs.length) { $cs.prop('required', true); }
            console.log('[AreaManagerNew] category change: manual');
            return;
        }

        // Regular case: show type dropdown, prepare Cm/Cs for auto-fill
        $typeInput.hide();
        // Do not submit manual text when regular mode is active
        $typeInput.prop('disabled', true);
        $typeSelect.show();
        $typeSelect.prop('disabled', false);
        // Validation: require type selection, not manual inputs
        if ($typeInput.length) {
            $typeInput.prop('required', false);
        }
        if ($typeSelect.length) {
            $typeSelect.prop('required', true);
        }
        if ($cm.length) {
            $cm.prop('required', false);
        }
		//if ($cs.length) { $cs.prop('required', false); }
        const categoryUid = parseInt(val || '0', 10);
        this.fillTypeOptions1381($block, categoryUid);

        if (initial && storedTypeUid) {
			$categorySelect.val(String(val));
            $typeSelect.val(String(storedTypeUid));
            // Trigger manual update of cm based on the stored type
            this.onTypeChange1381($typeSelect, true);
        } else {
            // Auto-select first type and fill Cm/Cs
            $typeSelect.trigger('change');
        }
        console.log('[AreaManagerNew] category change: uid', categoryUid);
    }

    fillTypeOptions1381($block, categoryUid) {
        const $typeSelect = $block.find(FormConfig.selectors.surfaceType1381Select);
        if (!$typeSelect.length || !$typeSelect[0]) {
            return;
        }
        $typeSelect[0].options.length = 0;
        if (this.surfaceTypesMap && this.surfaceTypesMap[categoryUid]) {
            this.surfaceTypesMap[categoryUid].forEach(t => {
                $typeSelect[0].add(new Option(t.name, String(t.uid)));
            });
        }
        // Auto-select first option if available
        if ($typeSelect[0].options.length > 0) {
            $typeSelect[0].selectedIndex = 0;
        }
    }

    onTypeChange1381($typeSelect, initial = false) {
        const $block = $typeSelect.closest(FormConfig.selectors.areaTypeBlock1381);
        const categoryUid = parseInt($block.find(FormConfig.selectors.surfaceCategory1381).val() || '0', 10);
        const val = $typeSelect.val();
        const $cm = $block.find(FormConfig.selectors.cm1381);
        //const $cs = $block.find(FormConfig.selectors.cs1381);

        if (!val) {
            // No type selected: clear Cm/Cs and disable
            $cm[0].options.length = 0;
            //$cs[0].options.length = 0;
            $cm.prop('disabled', true);
			this.disableIfSingleOption($cm);
            // Validation: keep type required; Cm not required in regular mode
            $cm.prop('required', false);
			//$cs.prop('required', false);
            this.host.updateSummary(); // CHANGE
            console.log('[AreaManagerNew] type change: no value');
            return;
        }

        // Regular type selected: auto-fill Cm/Cs from map
        let match = null;
        if (this.surfaceTypesMap && this.surfaceTypesMap[categoryUid]) {
            match = this.surfaceTypesMap[categoryUid].find(t => String(t.uid) === String(val));
        }
        if (match) {
            // Create single-option selects with auto-value (disabled to prevent editing)
            const toComma = n => String(n).indexOf('.') >= 0 ? String(n).replace('.', ',') : String(n);

            // If we are in initial mode, we might want to preserve a custom cm from the DB (e.g. if the norm changed)
            // but usually the norm value should win for regular types.
            const cmVal = toComma(match.cm);
            //const csVal = toComma(match.cs);

            $cm[0].options.length = 0;
            $cm[0].add(new Option(cmVal, cmVal));

            if (initial) {
                const storedCm = $cm.data('initial-value') || $cm.val();
                if (storedCm) {
                    // If storedCm is different from norm, we still show the option, but norm is usually the anchor.
                    // For now, let's ensure cmVal is correctly selected.
                    $cm.val(cmVal);
                } else {
                    $cm.val(cmVal);
                }
            } else {
                $cm.val(cmVal);
            }

            $cm.val(cmVal); // Ensure the value is set
            $cm.prop('disabled', true);

            /*$cs[0].options.length = 0;
            $cs[0].add(new Option(csVal, csVal));
            $cs.prop('disabled', true);*/
            console.log('[AreaManagerNew] type change: match', match);
        } else {
            // No match found: clear and disable
            $cm[0].options.length = 0;
            //$cs[0].options.length = 0;
            $cm.prop('disabled', true);
            //$cs.prop('disabled', true);
            $cm.prop('required', false);
			//$cs.prop('required', false);
            console.log('[AreaManagerNew] type change: no match');
        }
        this.host.updateSummary(); // CHANGE
    }

	toggleAreaCategorizationRows() {
		const rows = $(FormConfig.selectors.areacategorizationRow);
		rows.each((i, row) => {
			const $row = $(row),
				index = $row.parents(FormConfig.selectors.areacategorizationSelection).data('index'),
				surfaceCategory = parseInt($(FormConfig.selectors.surfaceCategory1381 + `[data-index="${index}"]`).val());

			if(
				(this.state.propertyType === null || $row.data('propertytypes').includes(this.state.propertyType)) &&
				(isNaN(surfaceCategory) || $row.data('surfacecategories').includes(surfaceCategory))
			) {
				$row.show();
			} else {
				$row.hide();
			}
		});
	}

	clearAreaCategorization($target) {
		const $areaBlock = $target.parents(FormConfig.selectors.areaTypeBlock1381),
			$selection = $areaBlock.find(FormConfig.selectors.areacategorizationSelection),
			index = $selection.data('index'),
			$display = $(`${FormConfig.selectors.areaCategorizationDisplayToggle}[data-index="${index}"]`),
			$input = $(`${FormConfig.selectors.areacategorizationInput}[data-index="${index}"]`),
			$areaInput = $areaBlock.find(FormConfig.selectors.areaInput);

		$selection.find(FormConfig.selectors.areacategorizationRow).removeClass('act');
		$input.val('');
		$display.val('');
		$areaInput.val('');
		this.host.updateFormData($input[0]);
	}
}
